/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Remove_TitleInputs */

const en_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove media version?`)
};

const fr_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la version média ?`)
};

const de_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienversion entfernen?`)
};

const it_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere la versione multimediale?`)
};

const ru_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить медиа-версию?`)
};

const es_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar la versión multimedia?`)
};

const zh_cn2_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除媒体版本？`)
};

const ja_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアバージョンを削除しますか？`)
};

const hi_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया संस्करण हटाएँ?`)
};

const pt_pt2_media_tab_remove_title = /** @type {(inputs: Media_Tab_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover versão para mídia?`)
};

/**
* | output |
* | --- |
* | "Remove media version?" |
*
* @param {Media_Tab_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_remove_title = /** @type {((inputs?: Media_Tab_Remove_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Remove_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_remove_title(inputs)
	if (locale === "de") return de_media_tab_remove_title(inputs)
	if (locale === "it") return it_media_tab_remove_title(inputs)
	if (locale === "ru") return ru_media_tab_remove_title(inputs)
	if (locale === "es") return es_media_tab_remove_title(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_remove_title(inputs)
	if (locale === "ja") return ja_media_tab_remove_title(inputs)
	if (locale === "hi") return hi_media_tab_remove_title(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_remove_title(inputs)
	return en_media_tab_remove_title(inputs)
});